import React from 'react';
import Input from '../Input/Input.js';
import standardInput from '../hocs/StandardInputHOC.js';
import { jsx as _jsx } from "react/jsx-runtime";
function StandardEmailInput(props) {
  return /*#__PURE__*/_jsx(Input, {
    "data-cmp": "standardEmailInput",
    label: "Email",
    type: "email",
    ...props
  });
}
export default /* #__PURE__ */standardInput(StandardEmailInput, {
  validations: {
    isEmail: true
  },
  validationError: 'Enter a valid email address',
  validationErrors: {
    isDefaultRequiredValue: 'Enter your email address'
  }
});